const baseUrl = 'https://cdn.scoreupup.com/'
export default baseUrl


// WEBPACK FOOTER //
// ./src/api/common.js